/* eslint no-undef:0, no-unused-expressions:0, array-callback-return:0 */
import React, { Component } from 'react';

import { Icon } from '@icedesign/base';
import Layout from '@icedesign/layout';

import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';

import cx from 'classnames';
import { enquire } from 'enquire-js';

import ScreenWidget from '@/components/ScreenWidget';

import Authorized from '../../auth/Authorized';
import Initializer from '../../initailizer';
import Footer from '../Footer';
import Header from '../Header';
import LayoutHOC from '../LayoutHOC';

import './scss/dark.scss';
import './scss/light.scss';

@LayoutHOC
@withRouter
class FactoryLayout extends Component {
  static propTypes = {};

  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {
      openDrawer: false,
      isScreen: undefined,
    };
  }

  componentDidMount() {
    this.enquireScreenRegister();
  }

  componentWillUnmount() {
    // EventEmitter.removeAllListeners();
  }

  /**
   * 注册监听屏幕的变化，可根据不同分辨率做对应的处理
   */
  enquireScreenRegister = () => {
    const isMobile = 'screen and (max-width: 720px)';
    const isTablet = 'screen and (min-width: 721px) and (max-width: 1199px)';
    const isDesktop = 'screen and (min-width: 1200px)';

    enquire.register(isMobile, this.enquireScreenHandle('isMobile'));
    enquire.register(isTablet, this.enquireScreenHandle('isTablet'));
    enquire.register(isDesktop, this.enquireScreenHandle('isDesktop'));
  };

  enquireScreenHandle = type => {
    let collapse;
    if (type === 'isMobile') {
      collapse = false;
    } else if (type === 'isTablet') {
      collapse = true;
    } else {
      collapse = this.state.collapse;
    }

    const handler = {
      match: () => {
        this.setState({
          isScreen: type,
          collapse,
        });
      },
      unmatch: () => {
        // handler unmatched
      },
    };

    return handler;
  };

  /**
   * 响应式通过抽屉形式切换菜单
   */
  toggleMenu = () => {
    const { openDrawer } = this.state;
    this.setState({
      openDrawer: !openDrawer,
    });
  };

  render() {
    const { theme, wideScreen } = this.props;

    return (
      <Layout
        style={{ minHeight: '100vh' }}
        className={cx(
          `ice-design-header-aside-footer-${wideScreen ? 'responsive-' : ''}layout-${theme}`,
          {
            'ice-design-layout': true,
            'factory-layout': true,
            'wide-layout': !!wideScreen,
          }
        )}
      >
        {/* 在这个组件内部做一些系统的初始化配置 */}
        <Initializer
          wrappedComponentRef={com => {
            this.initializer = com;
          }}
          notVerifyLogin
        />

        <Header
          theme={theme}
          isMobile={this.state.isScreen !== 'isDesktop'}
          hideHeaderMenu
          sdkInfo={this.props.sdkResult}
          onGetSocketService={() => this.initializer.getSocketService()}
          onReadKey={() => this.initializer.readKeyInfo()}
        />
        <ScreenWidget />
        <Layout.Section className="ice-design-layout-body">
          {this.state.isScreen !== 'isDesktop' && (
            <a className="menu-btn" onClick={this.toggleMenu}>
              <Icon type="category" size="small" />
            </a>
          )}

          {this.state.openDrawer && <div className="open-drawer-bg" onClick={this.toggleMenu} />}
          {/* 主体内容 */}
          <Layout.Main>{this.getRouteScreen(this.props.children)}</Layout.Main>
        </Layout.Section>
        <Footer />
      </Layout>
    );
  }

  /**
   *  获取当前的路由并判断是否有权限方位，没有权限重定向至403
   */
  getRouteScreen = screen => {
    // console.log(screen);
    return this.checkPermissionRoute(
      // 在router.jsx中注入到页面props中的authority属性
      screen.props.authority,
      // 这里期望接收的是真正的组件 - <Component/>
      screen,
      <Redirect to={{ pathname: '/exception/403' }} />
    );
  };

  /**
   * 页面路由权限检查
   */
  checkPermissionRoute = (authority, ItemDom, redirectView) => {
    if (Authorized.check) {
      const { check } = Authorized;
      return check(authority, ItemDom, redirectView);
    }
    return ItemDom;
  };
}

function mapStateToProps(store) {
  return {
    profileResult: store.profileReducer.profile,
    sdkResult: store.sdkReducer,

    theme: store.systemReducer.wideScreen ? 'light' : store.systemReducer.theme,
    // 如果启动了集成模式，则强制使用宽屏模式
    wideScreen: store.systemReducer.integrationScreen || store.systemReducer.wideScreen,
  };
}

export default connect(mapStateToProps)(FactoryLayout);
